<template>
    <div class="personSearch">
        <!-- 头部 -->
        <publicHeaders></publicHeaders>

        <!-- 主体 -->
        <div class="main">
            <div class="left">
                <div class="tab">
                    <span>您所在的位置：</span>
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                      <el-breadcrumb-item>{{ documentTitle }}</el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
                <div class="content">
                    <div class="input">
                        <el-input
                          placeholder="请输入查询关键字"
                          suffix-icon="el-icon-search"
                          v-model="input">
                        </el-input>
                        <el-button type="primary" @click="getList">搜索</el-button>
                    </div>
                    <div class="result">
                        <el-empty class="empty" description="暂无数据" v-if="empty"></el-empty>
                        <ul v-if="!empty">
                            <li v-for="(item, index) in resultList" :key="index" @click="toPersonDetail(item, documentTitle)">
                                <img :src="baseUrl + item.peopleImg" alt="" @error="imgerrorfun">
                                <div class="title">
                                    <div>{{ item.name }}</div>
                                    <div>{{ item.workUnit }}</div>
                                </div>
                            </li>
                        </ul>
                        <el-pagination @current-change="currentChange"
                          v-if="!empty"
                          background
                          :current-page="page"
                          :page-size="12"
                          layout="prev, pager, next, jumper"
                          next-text="下一页"
                          prev-text="上一页"
                          :total="total">
                        </el-pagination>
                        <div style="text-align: center;font-size: 12px;color: #666;margin-top: 10px;">最多显示50条,如需更多,请输入更精准的查询条件</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 底部 -->
        <div style="position: absolute;bottom: 0;left: 50%;transform: translateX(-50%);width: 100%;">
            <foot></foot>
        </div>
    </div>
</template>

<script>
import * as api from '../../api/api'
import { decrypt } from '../../utils/decode'
import publicHeaders from '../../components/header.vue'
import foot from '../../components/foot.vue'
import {baseURL} from '../../api/network.js';
export default {
    name: 'personSearch',
    components: {
        publicHeaders,
        foot
    },
    data() {
        return {
            documentTitle: '',
            baseUrl: baseURL,
            input: '',
            empty: true,
            resultList: [
                // {
                //     title: '赵华良',
                //     imgUrl: require('../../assets/img/index/expert.png'),
                //     company: '北京菜鸟物流有限公司北京菜鸟物流有限公司'
                // },
                // {
                //     title: '赵华良',
                //     imgUrl: require('../../assets/img/index/expert.png'),
                //     company: '北京菜鸟物流有限公司北京菜鸟物流有限公司'
                // },
                // {
                //     title: '王佛兰',
                //     imgUrl: require('../../assets/img/index/entrepreneurt.png'),
                //     company: '北京菜鸟物流有限公司北京菜鸟物流有限公司'
                // },
                // {
                //     title: '王佛兰',
                //     imgUrl: require('../../assets/img/index/entrepreneurt.png'),
                //     company: '北京菜鸟物流有限公司北京菜鸟物流有限公司'
                // },
                // {
                //     title: '赵华良',
                //     imgUrl: require('../../assets/img/index/expert.png'),
                //     company: '北京菜鸟物流有限公司北京菜鸟物流有限公司'
                // },
                // {
                //     title: '赵华良',
                //     imgUrl: require('../../assets/img/index/expert.png'),
                //     company: '北京菜鸟物流有限公司北京菜鸟物流有限公司'
                // },
            ],
            total: 0,
            page: 1,
        }
    },
    watch: {
        '$route.query.documentTitle': {
            immediate: true,
            handler(newVal, oldVal) {
                // console.log(newVal);
                this.documentTitle = this.$route.query.documentTitle
                this.searchPlaceholder = this.$route.query.documentTitle
                document.title = this.$route.query.documentTitle

                this.resultList = []
                this.getList()
            }
        }
    },
    created() {
        window.scrollTo(0 ,0)
        this.documentTitle = this.$route.query.documentTitle
        this.searchPlaceholder = this.$route.query.documentTitle
        document.title = this.$route.query.documentTitle

        
        this.resultList = []

        window.addEventListener('keydown', this.handkeyCode, true)
        this.getList()
    },
    destroyed() {
        window.removeEventListener('keydown', this.handkeyCode, true)
    },
    methods: {
        // 回车搜索
        handkeyCode(e) {
        //    console.log(e);
           if (e.keyCode === 13){
               this.getList()
           }
        },

        // 查询列表
        getList() {
            let _this = this
            _this.resultList = []
            _this.empty = true
            // console.log(this.input);
            let params = {
                param: this.input,
                page: _this.page,
                limit: 12
            }
            // if (this.input == '') {
            //     _this.$message.error('请输入关键词')
            // } else {
                if (this.documentTitle == '信用专家') {
                    api.getExpertList(params).then(res => {
                        let { data } = res
                        // console.log(data);
                        if (data.status == 200) {
                            _this.resultList = data.data.data
                            _this.total = data.data.total
                            if (_this.total == 0) {
                                _this.empty = true
                            } else {
                                _this.empty = false
                            }
                        } else {
                            
                        }
                    })
                    .catch(error => {
                    //   _this.$toast('网络错误，请检查网络')
                    })
                } else {
                    api.getEnterpreneurList(params).then(res => {
                        let { data } = res
                        // console.log(data);
                        if (data.status == 200) {
                            _this.resultList = data.data.data
                            _this.total = data.data.total
                            if (_this.total == 0) {
                                _this.empty = true
                            } else {
                                _this.empty = false
                            }
                        } else {
                            
                        }
                    })
                    .catch(error => {
                    //   _this.$toast('网络错误，请检查网络')
                    })
                }
            // }
        },

        // 分页
        currentChange(val) {
            this.page = val;
            this.getList()
        },

        // 图片错误回调
        imgerrorfun(e) {
            var img = e.srcElement;
            // console.log(img);
            img.src = require('../../assets/img/index/person.webp');
            img.onerror = null; //控制不要一直跳动 
        },

        // 前往详情
        toPersonDetail(item, title) {

            // let routeUrl = this.$router.resolve({
            //   path: "/personDetail"
            // });
            let text = title + '详情'

            this.$router.push({
                name: 'personDetail',
                query: {
                    documentTitle: text,
                    id: item.id
                }
            })
            // console.log(routeUrl);
            // window.open(routeUrl.href+ '?documentTitle=' + text + '&id=' + item.id, '_blank');
        },

        
    }
}
</script>

<style lang="less" scoped>
.personSearch {
    position: relative;
    padding-bottom: 140px;
    .main {
        width: 80%;
        padding: 15px 50px;
        margin: 0 auto;
        @media only screen and (min-width: 769px) {
            min-width: 1152px;
        }
        .left {
            margin-right: 5px;
            .tab {
                background-color: #F2F2F2;
                display: flex;
                align-items: center;
                font-size: 16px;
                padding: 5px 10px;
            }
            .content {
                min-height: 500px;
                border: 1px solid #D9D9D9;
                margin-top: 10px;
                padding: 20px 100px;
                .input {
                    display: flex;
                    justify-content: space-between;
                    /deep/ .el-input {
                        width: 90%;

                    }
                    /deep/ .el-button {
                        border-radius: 1px;
                        background-color: #1A68E8;
                        width: 94px;
                    }
                    /deep/ .el-input__inner {
                        height: 48px;
                        line-height: 48px;
                        font-size: 18px;
                        color: #999;
                    }
                    /deep/ .el-input__icon {
                        font-size: 26px;
                        width: 35px;
                        line-height: 50px;
                        color: #999;
                    }
                }
                .result {
                    padding: 20px;
                    background-color: #F2F7FF;
                    margin-top: 15px;
                    ul {
                        overflow: hidden;
                        padding-bottom: 20px;
                        min-height: 300px;
                    }
                    li {
                        float: left;
                        width: 25%;
                        display: flex;
                        justify-content: center;
                        align-items: top;
                        font-size: 18px;
                        color: #111;
                        padding: 0 15px 25px 0;
                        cursor: pointer;
                        img {
                            width: 100px;
                            height: 85px;
                            object-fit: contain;
                        }
                        .title {
                            overflow: hidden;
                            display: -webkit-box;
                            -webkit-line-clamp: 3;
                            -webkit-box-orient: vertical;
                            word-break: break-all;
                            width: 100px;
                            margin-left: 10px;
                        }
                    }
                    li:hover {
                        .title {
                            color: #258AFF;
                        }
                    }
                    /deep/ .el-pagination {
                        display: flex;
                        justify-content: center;
                    }
                    /deep/ .el-pager li {
                        background: #fff;
                        border: 1px solid #ddd;
                        border-radius: 1px;
                        margin: 0;
                        height: 34px;
                        line-height: 34px;
                        width: 34px;
                    }
                    /deep/ .el-pager li:nth-of-type(n+2) {
                        border-left: none;
                    }
                    /deep/ .btn-next {
                        margin: 0;
                        height: 34px;
                        line-height: 34px;
                        padding: 0 15px;
                        display: flex;
                        align-items: center;
                        background: #fff;
                        border: 1px solid #ddd;
                        border-left: none;
                    }
                    /deep/ .btn-prev {
                        margin: 0;
                        height: 34px;
                        line-height: 34px;
                        padding: 0 15px;
                        display: flex;
                        align-items: center;
                        background: #fff;
                        border: 1px solid #ddd;
                        border-right: none;
                    }
                    /deep/ .el-pager li:not(.disabled).active {
                        background-color: #1A68E8;
                    }
                }
            }
        }
    }
}
</style>